import React from 'react';
import { Helmet } from 'react-helmet';
import { generateUniqueID } from "web-vitals/dist/modules/lib/generateUniqueID";

import Animation from "../animation/animation";
import ContactForm from "../contact-form/contact-form";
import SubCategory from "../subcategory/subcategory";
import Projects  from  '../../data/projects.json';

import '../services/services.scss';
import './category.scss';



const Category = ({ tag }) => {
  const {
    title,
    description,
    subcategories,
    header,
    seoTitle,
    metaDescription
  } = Projects[tag];
  const subContainer = React.useRef();
  const metaTitle = seoTitle.replace('&nbsp;', ' ') + ' – Заказать в Студии Артемия Лебедева';

  const initWorks = () => {
    const container = subContainer.current;

    if (!container) {
      return;
    }


    window.includeWorks.init();
  }

  React.useEffect(() => {
    initWorks();
  }, [])

  return (
      <React.Fragment>
        <Helmet>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDescription} />
        </Helmet>
        <div className="services services-category">
          <div className="services-header">
            <h1 className="services-header__text" dangerouslySetInnerHTML={{__html: title}} />
            <Animation tag={tag} header={header} />
            <div className="als-text-container">
              <p className="services__text"
                 dangerouslySetInnerHTML={{__html: description}}
              />
            </div>
          </div>

          <div ref={subContainer} className="subcategories">
            {
              Object.entries(subcategories).map(subcategory => {
                return (
                    <SubCategory key={generateUniqueID()} {...subcategory[1]}/>
                )
              })
            }
          </div>

          <ContactForm formId={tag}/>

        </div>
      </React.Fragment>
  );
}

export default Category;
